<template>
    <span class="badge badge-dark" style="font-size: 12.8px">
        <i class="mdi mdi-clock"></i>
        {{ duration / 60 }} Min
    </span>
</template>

<script>
export default {
    name: "GymVideoDurationBadge",
    props: {
        duration: {
            type: Number,
            required: true
        },
    },
}
</script>

<style scoped>

</style>
